import React from 'react';

import SearchButton, {
  SearchButtonGroup
} from '../../../../../../components/search-button/search-button';
import CommentsDuotoneIcon from '../../../../../../shared/icons/comments-duotone-icon';
import Button from '../../../../../button/button';
import Typography from '../../../../../typography/typography';
import { TABS } from '../../../../fitment-constants';
import { TabOption } from '../../../../fitment-types';

import './fitment-cant-find-alternate-shop-options.scss';

interface FitmentCantFindAlternateShopOptionsProps {
  className?: string;
  hideShopBySize?: boolean;
  onShopByClick: (tab: TabOption) => void;
}

function FitmentCantFindAlternateShopOptions(
  props: FitmentCantFindAlternateShopOptionsProps
) {
  const { className = '', hideShopBySize = false, onShopByClick } = props;

  const lpChatButton: HTMLButtonElement | null = document.querySelector(
    '[aria-label="CHAT"]'
  );

  return (
    <div
      className={`fitment-cant-find-alternate-shop-options ${className}`}
      data-testid="fitment-cant-find-alternate-shop-options"
      styleName="container"
    >
      <Typography styleName="contact-ctas" tag="div" variant="H6">
        {lpChatButton && (
          <div>
            <CommentsDuotoneIcon styleName="chat-icon" />
            <Button onClick={() => lpChatButton.click?.()} size="regular">
              Chat with us!
            </Button>
          </div>
        )}
      </Typography>

      <SearchButtonGroup>
        {!hideShopBySize && (
          <SearchButton
            label="Shop by Size"
            onClick={() => onShopByClick(TABS.SIZE)}
          >
            <img
              alt="Choose Tires"
              src="https://www.tirerack.com/images/css_elements/tireSizeHelpGraphic2.png"
              width="100%"
            />
          </SearchButton>
        )}

        <SearchButton
          label="Shop by Brand"
          onClick={() => onShopByClick(TABS.BRAND)}
        >
          <img
            alt="Choose Tires"
            src="https://discounttire.scene7.com/is/image/discounttire/T_G_hero_tire_basics_001?wid=200&resMode=sharp2&op_usm=1.25,0.3,2,0"
          />
        </SearchButton>
      </SearchButtonGroup>
    </div>
  );
}

export default FitmentCantFindAlternateShopOptions;
